import React from "react";
import Carousel from 'react-bootstrap/Carousel';
import "swiper/css";
import {Link} from "react-router-dom"

const FeatureCard = ({ title, description }) => (
  <div className="feature-card">
    <h3>{title}</h3>
    <p>{description}</p>
  </div>
);

const MainPage = () => {
  return (
    <div className="landing-page">
      {/* Header */}

      {/* Hero Section */}
      <section className="hero">
        <div className="container">
          <h1>Simplify Your Auction Trading</h1>
          <p>
            Web and mobile applications that give you full control and clarity
            over your IAAI and Copart trading. Stay ahead of the competition with
            real-time updates and intelligent tools.
          </p>
          <a href="#features" className="cta-btn">Explore Features</a>
        </div>
      </section>

      {/* Features Section */}
      <section id="features" className="features">
        <div className="container">
          <h2>Key Features</h2>
          <div className="features-grid">
            <FeatureCard title="24/7 Support" description="Always-on help from our dedicated support team — any time, any place." />
            <FeatureCard title="Live Auction Insights" description="Track bids, vehicles, and updates in real time without missing a beat." />
            <FeatureCard title="User-Friendly Extensions" description="Streamline your auction experience with our Copart & IAAI browser tools." />
          </div>
        </div>
      </section>

      {/* Why Choose Us */}
      <section className="why-choose-us">
        <div className="container">
          <div className="text">
            <h2>Why Users Love Our Extension</h2>
            <p>
              Simplifies the auction process with a modern UI, data-rich
              insights, and real-time bidding updates. Save time and make smarter
              decisions — faster.
            </p>
            <p>
              With one-click access to everything, our tools are trusted by
              professionals who trade daily and need performance that keeps up.
            </p>
          </div>
          <img src="/static/01.png" alt="Extension Preview" />
        </div>
      </section>

      {/* Platform Capabilities */}
      <section id="platform" className="platform">
        <div className="container">
          <h2>Platform Management</h2>
          <div className="features-grid">
            <FeatureCard title="Copart & IAAI Account Management" description="Securely connect and manage your auction accounts in one place." />
            <FeatureCard title="User Roles & Access" description="Add multiple users and manage access with precision controls." />
            <FeatureCard title="Bid History & Activity Logs" description="See who placed what, when, and track every action across accounts." />
          </div>
        </div>
      </section>
      <section id="platform" className="platform">
        <div className="container">
          <Carousel>
            <Carousel.Item>
              <img src="/static/03.png" style={{width: "100%"}} alt="image" />
              {/* <ExampleCarouselImage text="First slide" /> */}
              <Carousel.Caption>
                <h3>First slide label</h3>
                <p>Nulla vitae elit libero, a pharetra augue mollis interdum.</p>
              </Carousel.Caption>
            </Carousel.Item>
            <Carousel.Item>
              <img src="/static/04.png" style={{width: "100%"}} alt="image" />
              {/* <ExampleCarouselImage text="Second slide" /> */}
              <Carousel.Caption>
                <h3>Second slide label</h3>
                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>
              </Carousel.Caption>
            </Carousel.Item>
          </Carousel>
        </div>
      </section>

      {/* Support CTA */}
      <section id="support" className="support">
        <div className="container">
          <h2>Need Help?</h2>
          <p>Our support team is available 24/7 to help you with setup, questions, and issues.</p>
          <Link to="/" className="cta-btn">Contact Support</Link>
        </div>
      </section>

      {/* Footer */}
    </div>
  );
};

export default MainPage;
